import React from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { useApiCallable } from '../api';

interface PublishingConfig {
  contentType: string;
  apiPath: string;
  existingId?: string;
}

export function usePublishing(
  config: PublishingConfig,
  onFormSubmit: () => void,
) {
  const navigate = useNavigate();
  const callApi = useApiCallable();
  const savingDraft = React.useRef(false);
  const savedContentId = React.useRef(config.existingId);
  const isSubmittingRef = React.useRef(false);

  const handleSaveDraft = () => {
    savingDraft.current = true;
    onFormSubmit();
  };

  const handlePublish = () => {
    savingDraft.current = false;
    onFormSubmit();
  };

  const handleSubmitSuccess = async (response: any, isExisting: boolean) => {
    isSubmittingRef.current = true;

    if (!isExisting && response?.data?.['@id']) {
      savedContentId.current = response.data['@id'].split('/').pop();
    }

    if (savingDraft.current) {
      navigate(-1);
      toast.success(
        isExisting
          ? `${config.contentType} updated successfully`
          : `${config.contentType} saved as draft`,
      );
      savingDraft.current = false;
      return;
    }

    if (savedContentId.current) {
      const publishResponse = await callApi(
        `/${config.apiPath}/${savedContentId.current}/mark-as-published`,
        {
          method: 'POST',
          jsonBody: {},
        },
      );

      if (publishResponse) {
        toast.success(`${config.contentType} published successfully`);
        navigate(-1);
      }
    }
  };

  return {
    handleSaveDraft,
    handlePublish,
    handleSubmitSuccess,
    savingDraft,
    isSubmittingRef,
  };
}
